import { useContext, useEffect, useState } from "react";
import { AccountContext } from "./AccountProvider";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Accounts/DeleteServerConnection.css";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import { AppContext } from "../../../AppProvider";
import { User } from "@auth0/auth0-react";

const DeleteServerConnection = () =>{
    const {user,logout} = useContext(AppContext);
    const {selectedDeleteTenantAdminProfile,setSelectedDeleteTenantAdminProfile} = useContext(AccountContext);
    const [tenantAdministratorProfileDeleteStatus,setTenantAdministratorProfileDeleteStatus] = useState('');
    const deleteTenantAdministratorProfile = async() =>{
        try{
            setTenantAdministratorProfileDeleteStatus('deleting');
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedDeleteTenantAdminProfile?.id}`;
            const response = await fetch(url,{
                method:'DELETE',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok) setTenantAdministratorProfileDeleteStatus('deleted');
            else if(response.status === 401) logout();
            else throw new Error(`response status: ${response.status}`);
        }
        catch(error){
            console.error(`An error occurred when deleting tenant administrator profile with id: ${selectedDeleteTenantAdminProfile?.id}`,error);
        }
    };
    const disposeWindow =  () =>{
        setSelectedDeleteTenantAdminProfile(null);
        setTenantAdministratorProfileDeleteStatus('');
    };
    if(!selectedDeleteTenantAdminProfile) return null;
    return(
        <div className="tenant-administrator-account-delete-server-connection-parent-container">
            {tenantAdministratorProfileDeleteStatus === ''?
            (<div className="tenant-administrator-account-delete-server-connection-container">
                <h1>Are you sure you want to delete the server connection "{selectedDeleteTenantAdminProfile?.profileName}"</h1>
                <p>Be careful, after the confirmation, the server connection and all related configuration will become unrecoverable.</p>
                <div className="control-buttons-container">
                    <button onClick={() => disposeWindow()}>No</button>
                    <button onClick={async() => await deleteTenantAdministratorProfile()}>Yes</button>
                </div>
            </div>):tenantAdministratorProfileDeleteStatus === 'deleting'?
            (<div className="tenant-administrator-account-deleting-server-connection-container">
                <div></div>
                <p>Deleting server connection, please wait...</p>
            </div>):
            (<div className="tenant-administrator-account-deleted-server-connection-container">
                <p><span>&#10003;</span>Server connection "{selectedDeleteTenantAdminProfile?.profileName} deleted successfully"</p>
                <div className="control-buttons-container">
                    <button onClick={() => disposeWindow()}>Okay</button>
                </div>
            </div>)}
        </div>
    );
};
export default DeleteServerConnection;